<template>
  <div>
    <Input type="textarea" :autosize="{minRows: 7}" @on-change="change"  v-model="value"/>
    <a @click="yulan" style="font-weight: bold;color: red;">点击效果预览！！！</a>

    <cite>|</cite>
    请务必仔细查看使用说明：
    <a href="https://www.yuque.com/docs/share/31345305-d849-47d9-b1bc-39c6b8a13fe0" target="_blank">点击查看</a>
    <UploadOne v-model="fid"></UploadOne>
    <p v-if="fid">----https://api.efclink.com/api/upload/online/{{fid}}</p>
    <p>图片需要加4个中杠线，【----】</p>
    <Modal
      v-model="modal1"
      width="400"
      title="显示效果预览，小程序显示效果需要在小程序中看">
      <template v-for="item in list">
        <p v-if="item.type==='h1'" class="cjw_ht_module_t1 cjw_ht_module">{{item.text}}</p>
        <p v-if="item.type==='h2'" class="cjw_ht_module_t2 cjw_ht_module">{{item.text}}</p>
        <p v-if="item.type==='h3'" class="cjw_ht_module_t3 cjw_ht_module">{{item.text}}</p>
        <img v-if="item.type==='img'" :src="item.text" style="width: 100%"/>
        <p v-if="item.text==='line008645'">&nbsp;</p>
      </template>

    </Modal>

  </div>
</template>

<script>
  import UploadOne from "../../public/upload/UploadOne";
  export default {
    components:{UploadOne},
    props:['value'],
    data(){
      return{
        modal1:false,
        list:[],
        fid:0,
      }
    },
    methods:{
      change(){
        this.$emit('input',this.value);
        this.$emit('on-change');
      },
      yulan(){// 根据text代码，预览出效果
        let that = this;
        let data ={text:this.value};
        this.$axios({url:'/api/zixun/yulan',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.modal1 = true;
          that.list = rs.data;
        });
      },
    }

  }
</script>




// WEBPACK FOOTER //
// src/components/common/JsonInput.vue